class TicketPaginationValues {
    constructor(public sortBy: string, public descending: boolean = true
        , public page: number, public rowsPerPage: number, public onSite: boolean | null
        , public ticketStatusId: string[], public ignoreTicketStatusId: string[]
        , public assignedToId: string[] | null, public contactId: number, public tagId: string[] | null
        , public ticketPriorityId: string[] | null
        , public ticketSourceId: string[] | null, public clientId: number | null
        , public tickietGroupIds: number[] | null, public hasCheckList: boolean | null
        , public ticketCreatedOn: string | null, public ticketClosedOn: string | null, public isTicketProduct: boolean | null
        , public Query: string = "", public recentlyUpdatedInHours: number = 0, public hasAllTicketTags: boolean) {

    }
}
export { TicketPaginationValues };
